import React, { FC, useMemo } from "react";

// Define the Room interface
interface Room {
 [key : string]: any;
}

// Props for the component
interface RoomSummaryProps {
    item: Room[];
    infants?: any
}

// Reusable function to generate the summary
const generateRoomSummary = (item: any, infants?: any): any => {
    // console.log("Rooms", item);
  let totalRooms: number = 0;
  let totalAdults: number = 0;
  let totalChildren: number = 0;
  let totalInfants: any  = infants || 0;

  item?.rooms?.forEach((room: any) => {
    totalRooms += room.no_of_rooms;
    totalAdults += room.no_of_adults;
    totalChildren += room.no_of_children;
  });

  const childrenPart = totalChildren > 0 ? `and ${totalChildren} Child${totalChildren > 1 ? "ren" : ""}` : "";
  const infantsPart = totalInfants > 0 ? `,${totalInfants}  Infant${totalInfants > 1 ? "s" : ""}` : "";
  return `${totalRooms} Room${totalRooms > 1 ? "s" : ""}, ${totalAdults} Adult${totalAdults > 1 ? "s" : ""} ${infantsPart} ${childrenPart}`;
};

// React component to display the room summary
export const RoomSummary: FC<RoomSummaryProps> = ({ item, infants }) => {
    // console.log("Rooms", item);
  // useMemo to optimize recalculating the summary only when rooms data changes
  const roomSummary = useMemo(() => generateRoomSummary(item, infants), [item, infants]);

  return <div>{roomSummary}</div>;
};


